import { useLayoutEffect, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/i/$code")({
  component: Redirect,
});

function Redirect() {
  const { code } = Route.useParams();

  useLayoutEffect(() => {
    window.location.href = `https://api.graze.social/app/api/v1/link-tracking/l/${code}`;
  }, [code]);

  return null;
}
